import { Button, NextUIProvider, Spinner } from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import { Link, Navigate, Outlet, useNavigate } from "react-router-dom";
import Header from "../components/header";
import { useAuth } from "../contexts/auth-context";
import fetchWrapper from "../utils/fetch";
import CopyToClipboard from "react-copy-to-clipboard";
import { toast } from "react-toastify";

export default function MyDecisions() {
  const [{ isAuthenticated, requested }] = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [decisions, setDecisions] = useState([]);
  const [deletedCount, setDeletedCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    fetchWrapper
      .get("/get/problems")
      .then((data) => {
        setDecisions(data.problems);
        setIsLoading(false);
      })
      .catch((err) => {
        if (err?.detail === "not found") {
          toast.error("این تمپلیت موجود نیست");
          navigate("/");
        } else if (err?.detail === "Invalid credentials") {
          toast.error("نام کاربری یا رمز عبور درست نیست.");
          navigate("/login");
        } else {
          toast.error(err);
        }
      });
  }, [setIsLoading, setDecisions, deletedCount, navigate]);

  const deleteProblem = (uid) => {
    const c = window.confirm("آیا مطمئن هستید ؟");
    if (c) {
      fetchWrapper
        .post("/problem/delete", {
          problem_uid: uid,
        })
        .then((data) => {
          setDeletedCount((d) => d + 1);
          navigate("/my-decisions");
        })
        .catch((err) => {
          if (err?.detail === "not found") {
            toast.error("این تمپلیت موجود نیست");
            navigate("/");
          } else if (err?.detail === "Invalid credentials") {
            toast.error("نام کاربری یا رمز عبور درست نیست.");
            navigate("/login");
          } else {
            toast.error(err);
          }
        });
    }
  };

  if (requested) {
    if (isAuthenticated) {
      if (!isLoading) {
        return (
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 my-16">
            <div className="my-4">
              <h1 className="font-bold text-3xl">تصمیم‌های من </h1>
            </div>
            <hr />
            <ul className="divide-y divide-gray-100">
              {decisions.map((decision) => (
                <li
                  key={decision.problem_uid}
                  className="flex flex-wrap items-center justify-between gap-x-6 gap-y-4 py-5 sm:flex-nowrap"
                >
                  <div>
                    <p className="text-sm font-semibold leading-6 text-gray-900">
                      <Link
                        to={`/problem/create?template_id=${decision.problem_uid}`}
                        className="hover:underline text-xl text-blue-700 hover:text-blue-800"
                      >
                        {decision.problem_name}
                      </Link>
                    </p>
                    <div className="mt-2 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                      <p>
                        <span>اشتراک‌گذاری تصمیم: </span>
                        <CopyToClipboard
                          text={`${window.location.protocol}//${window.location.host}/problem/create?template_id=${decision.problem_uid}`}
                          onCopy={() =>
                            toast.success("لینک اشتراک‌گذاری با موفقیت کپی شد.")
                          }
                        >
                          {/* <span className="hover:underline font-mono cursor-pointer">
                            شناسه‌ی تصمیم: {decision.problem_uid}
                          </span> */}
                          <input
                            className="py-1 outline-none border 
                          border-gray-200 bg-gray-100 rounded-lg
                          pr-4 pl-2 w-64 text-gray-500"
                            value={`${window.location.protocol}//${window.location.host}/problem/create?template_id=${decision.problem_uid}`}
                          />
                        </CopyToClipboard>
                      </p>
                      <span className="text-sm font-bold text-red-500 mr-5">
                        <Button
                          color="primary"
                          variant="flat"
                          onClick={() =>
                            navigate(
                              `/problem/result?problem_id=${decision.problem_uid}`,
                            )
                          }
                        >
                          نمایش نتایج
                        </Button>
                      </span>
                    </div>
                    <div className="mt-4 flex items-center gap-x-2 text-xs leading-5 text-gray-500">
                      <p>
                        <Link
                          to={`/problem/create?template_id=${decision.problem_uid}`}
                          className="hover:underline"
                        >
                          <span className="hover:underline font-mono cursor-pointer">
                            شناسه‌ی تصمیم: {decision.problem_uid}
                          </span>
                        </Link>
                      </p>
                      <span className="text-sm font-bold text-red-500 mr-5">
                        <Button
                          color="danger"
                          variant="flat"
                          onClick={() => deleteProblem(decision.problem_uid)}
                        >
                          حذف
                        </Button>
                      </span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        );
      } else {
        return <Spinner size="lg" />;
      }
    } else {
      return <Navigate to="/login" />;
    }
  } else {
    return <Spinner size="lg" />;
  }
}
